var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIconSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9866 12.2245C23.9866 11.2412 23.9049 10.5237 23.7282 9.77963H12.2383V14.2176H18.9826C18.8467 15.3205 18.1124 16.9815 16.4807 18.0975L16.4578 18.2461L20.0907 20.9963L20.3424 21.0209C22.654 18.9347 23.9866 15.8653 23.9866 12.2245Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2391 23.9175C15.5433 23.9175 18.3171 22.8545 20.3432 21.0209L16.4815 18.0975C15.4481 18.8018 14.0611 19.2934 12.2391 19.2934C9.00291 19.2934 6.25623 17.2073 5.27711 14.3239L5.13359 14.3359L1.35604 17.1927L1.30664 17.3269C3.31906 21.2334 7.45273 23.9175 12.2391 23.9175Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27678 14.324C5.01843 13.5799 4.86892 12.7826 4.86892 11.9588C4.86892 11.1349 5.01844 10.3377 5.26319 9.59357L5.25635 9.4351L1.43146 6.53238L1.30631 6.59055C0.476897 8.21165 0.000976562 10.0321 0.000976562 11.9588C0.000976562 13.8855 0.476897 15.7058 1.30631 17.3269L5.27678 14.324Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2391 4.62403C14.537 4.62403 16.0871 5.59401 16.971 6.4046L20.4248 3.10928C18.3036 1.18259 15.5433 0 12.2391 0C7.45272 0 3.31906 2.68406 1.30664 6.59056L5.26351 9.59358C6.25622 6.71019 9.0029 4.62403 12.2391 4.62403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIconSocial);
export default __webpack_public_path__ + "static/media/google-icon-social.3d4091ab02291fd817836fd13574af35.svg";
export { ForwardRef as ReactComponent };